import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d7aa41a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = {
  key: 0,
  class: "row"
}
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "col-sm-12 col-md-5" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "card-title" }
const _hoisted_9 = { class: "card-text" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_12 = { class: "card-text" }
const _hoisted_13 = { class: "card" }
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Top Products", -1))
const _hoisted_16 = { class: "list-group list-group-flush" }
const _hoisted_17 = { class: "col-sm-12 col-md-7" }
const _hoisted_18 = { class: "d-flex w-100 justify-content-between" }
const _hoisted_19 = { class: "mb-1" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "mb-1" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Donec id elit non mi porta.", -1))
const _hoisted_23 = {
  key: 1,
  class: "row"
}
const _hoisted_24 = { class: "col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_button = _resolveComponent("b-button")!
  const _component_StartRating = _resolveComponent("StartRating")!
  const _component_b_avatar = _resolveComponent("b-avatar")!
  const _component_b_badge = _resolveComponent("b-badge")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_b_list_group_item = _resolveComponent("b-list-group-item")!
  const _component_b_list_group = _resolveComponent("b-list-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.restorant)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_b_button, {
              variant: "link",
              onClick: _ctx.goBack
            }, {
              default: _withCtx(() => [
                _createTextVNode("Back")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: _ctx.restorant.image,
                class: "card-img-top",
                alt: "..."
              }, null, 8, _hoisted_6),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h5", _hoisted_8, _toDisplayString(_ctx.restorant.name), 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.restorant.description), 1),
                _hoisted_10,
                _createVNode(_component_StartRating, {
                  totalReviews: _ctx.restorant.totalReviews,
                  rate: _ctx.restorant.rate
                }, null, 8, ["totalReviews", "rate"]),
                _hoisted_11,
                _createElementVNode("p", _hoisted_12, [
                  _createTextVNode(" Usually arrives within "),
                  _createElementVNode("b", null, _toDisplayString(_ctx.restorant.timeToServe) + " minutes", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("ul", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topProducts, (product) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "list-group-item",
                        key: product.id
                      }, [
                        _createVNode(_component_b_avatar, {
                          src: product.image
                        }, null, 8, ["src"]),
                        _createTextVNode(" " + _toDisplayString(product.name), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_b_list_group, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.restorant.products, (product) => {
                  return (_openBlock(), _createBlock(_component_b_list_group_item, {
                    key: product.id,
                    class: "flex-column align-items-start"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("h5", _hoisted_19, [
                          _createVNode(_component_b_avatar, {
                            src: product.image
                          }, null, 8, ["src"]),
                          _createTextVNode(" " + _toDisplayString(product.name) + " ", 1),
                          _createVNode(_component_b_badge, null, {
                            default: _withCtx(() => [
                              _createTextVNode(" $ " + _toDisplayString(product.price), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("small", null, [
                          _createElementVNode("button", {
                            type: "button",
                            onClick: ($event: any) => (_ctx.addToCart(product.id)),
                            class: "btn btn-light btn-sm float-end"
                          }, [
                            _createVNode(_component_FontAwesomeIcon, { icon: _ctx.faPlus }, null, 8, ["icon"])
                          ], 8, _hoisted_20)
                        ])
                      ]),
                      _createElementVNode("p", _hoisted_21, _toDisplayString(product.description), 1),
                      _hoisted_22
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, " The restorant you are looking for could not be found " + _toDisplayString(_ctx.$route), 1)
        ]))
  ]))
}